import React, { useContext, useEffect, useState } from "react";
import MenuButton from "../MenuButton/MenuButton";
import UserServices from "../../UserServices/UserServices";
import { NoteState } from "../../context/notes/NoteState";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function VostroExpense() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;

  const [myBranches, setMyBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    branch_id: branch_id || "",
    date: new Date().toLocaleDateString("en-CA"),
    bank_funds: "",
    charity_cash: "",
    gst_cash: "",
    cash_in_hand: "",
    notes: "",
  });
  const [items, setItems] = useState([
    { description: "", amount: "" },
  ]);

  const fetchBranches = async () => {
    try {
      const response = await UserServices.branchName();
      const res = response.data.data;
      const branches = res.map((b) => ({ id: b.id, name: b.name }));
      setMyBranches([{ id: "", name: "Select Branch" }, ...branches]);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch branches", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const addRow = () => {
    setItems((prev) => [...prev, { description: "", amount: "" }]);
  };

  const removeRow = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated.length ? updated : [{ description: "", amount: "" }]);
  };

  const totalExpense = items.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const filteredItems = items.filter(
      (item) => item.description || item.amount
    );

    if (!filteredItems.length) {
      toast.error("Please add at least one expense item.", { autoClose: 3000 });
      return;
    }

    const payload = {
      ...formData,
      items: filteredItems.map((item) => ({
        description: item.description,
        amount: item.amount,
      })),
    };

    setLoading(true);
    try {
      const response = await UserServices.addVostroExpense(payload);
      if (response.status === 201) {
        toast.success("Daily expense saved", { autoClose: 3000 });
        setItems([{ description: "", amount: "" }]);
        setFormData((prev) => ({
          ...prev,
          bank_funds: "",
          charity_cash: "",
          gst_cash: "",
          cash_in_hand: "",
          notes: "",
        }));
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to save daily expense", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-20">
                Daily Expense
                <Link
                  to="/vostro-expense-report"
                  className="btn btn-primary d-inline-block float-end btn-sm"
                >
                  View Daily Expenses
                </Link>
              </h5>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Branch</label>
                    <select
                      className="form-select"
                      name="branch_id"
                      value={formData.branch_id}
                      onChange={handleHeaderChange}
                    >
                      {myBranches.map((branch, index) => (
                        <option key={index} value={branch.id}>
                          {branch.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={formData.date}
                      onChange={handleHeaderChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Bank Funds</label>
                    <input
                      type="number"
                      className="form-control"
                      name="bank_funds"
                      value={formData.bank_funds}
                      onChange={handleHeaderChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Charity Cash</label>
                    <input
                      type="number"
                      className="form-control"
                      name="charity_cash"
                      value={formData.charity_cash}
                      onChange={handleHeaderChange}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-3">
                    <label className="form-label">GST Cash</label>
                    <input
                      type="number"
                      className="form-control"
                      name="gst_cash"
                      value={formData.gst_cash}
                      onChange={handleHeaderChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Cash In Hand</label>
                    <input
                      type="number"
                      className="form-control"
                      name="cash_in_hand"
                      value={formData.cash_in_hand}
                      onChange={handleHeaderChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                    <input
                      type="text"
                      className="form-control"
                      name="notes"
                      value={formData.notes}
                      onChange={handleHeaderChange}
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase">Expense Items</h6>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addRow}
                    >
                      Add Row
                    </button>
                  </div>
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped add-expense-table">
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={item.description}
                                onChange={(e) =>
                                  handleItemChange(index, "description", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={item.amount}
                                onChange={(e) =>
                                  handleItemChange(index, "amount", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => removeRow(index)}
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td className="text-end fw-bold">Total</td>
                          <td colSpan="2" className="fw-bold">
                            {totalExpense}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Daily Expense"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
